// frontend/src/components/layout/index.tsx

import React, { useState } from "react";
import BottomBar from "../Bottombar";
import styles from "./layout.module.css";
import Seo from "../../utility/seo";
import Navbar from "../navbar";

type Props = { children: React.ReactNode };

const Layout = ({ children }: Props) => {
  return (
    <div className={styles.layoutRoot}>
      <Seo />
      <Navbar />
      <div>{children}</div>
      <BottomBar />
    </div>
  );
};

export default Layout;
